<form id="firmwareUpdateForm">
  <dialog-header>{{
    data.isMultiple
      ? 'Update Firmware on Multiple LG webOS Displays'
      : 'Update LG webOS Display Firmware'
  }}</dialog-header>

  <mat-dialog-content class="firmware-update-content">
    <!-- LG webOS Logo -->
    <div class="logo-container">
      <img
        src="/images/install/webos.png"
        alt="LG webOS"
        class="lg-webos-logo-image"
      />
    </div>

    <!-- Supporting Text -->
    <div class="supporting-text">
      Enter any valid URL to an LG webOS firmware file (.epk). For detailed
      steps on applying firmware,
      <a
        rv-link
        appearance="inline"
        href="https://help.risevision.com/hc/en-us/articles/43570178695828-Update-Firmware-on-LG-Display"
        target="_blank"
        class="instructions-link"
        >view the full instructions.</a
      >
    </div>

    <!-- Form -->
    <div class="form-container">
      <label class="form-label">Firmware file URL (must end with .epk)</label>
      <div class="input-frame">
        <input
          class="form-input"
          [formControl]="firmwareUrlControl"
          placeholder="http://www...epk"
          type="url"
        />
      </div>
      <div
        class="error-message"
        *ngIf="firmwareUrlControl.invalid && firmwareUrlControl.touched"
      >
        {{ getErrorMessage() }}
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="tw-gap-2.5">
    <div class="tw-flex-1">
      <button
        rv-button
        variant="secondary"
        type="button"
        class="w-full"
        (click)="onCancel()"
      >
        Cancel
      </button>
    </div>
    <div class="tw-flex-1">
      <button
        rv-button
        type="button"
        class="w-full"
        (click)="onUpdate()"
        [disabled]="firmwareUrlControl.invalid"
      >
        Update Firmware
      </button>
    </div>
  </mat-dialog-actions>
</form>
